import script from "./ButtonNew.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonNew.vue?vue&type=script&setup=true&lang=js"

import "./ButtonNew.vue?vue&type=style&index=0&id=597e3011&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-597e3011"]])

export default __exports__